import script from "./image-item-web.vue?vue&type=script&setup=true&lang=ts"
export * from "./image-item-web.vue?vue&type=script&setup=true&lang=ts"

import "./image-item-web.vue?vue&type=style&index=0&id=7df85add&lang=scss"

const __exports__ = script;

export default __exports__